export default "__VITE_ASSET__c49501e2__"